module.exports = function loadScript(src, callback, dataMain) {
  const head = document.getElementsByTagName('head')[0]
  const script = document.createElement('script')

  script.type = 'text/javascript'
  if (dataMain) {
    script.setAttribute('data-main', dataMain)
  }
  script.src = src

  script.onload = callback
  script.onerror = callback

  head.appendChild(script)
}
